import type SceneControl from '../scene/scene'

const useComposerFrame = (sceneControl: SceneControl, cb: () => void) => {
  sceneControl.context.addFrameComposerFrameRender(cb)
  return () => sceneControl.context.removeFrameComposerFrameRender(cb)
}

export default useComposerFrame
